import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "title"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "break-word" }

import Vue3Modal from "@SharedVueComponents/Modal/Vue3Modal.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrustItem',
  props: {
    src: {},
    label: {},
    caption: {},
    infoText: {},
    loginWrapper: {}
  },
  setup(__props: any) {



const modalActive = ref(false);

function openModal() {
	modalActive.value = true;
}
function closeModal() {
	modalActive.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: "mx-3 mb-0 min-w-[80px] cursor-pointer text-center",
    onClick: openModal
  }, [
    _createElementVNode("img", {
      src: `/_ui/responsive/common/images/trustIcons/${_ctx.src}`,
      alt: _ctx.label,
      title: _ctx.label,
      class: "mb-3 inline-block h-auto w-[48px]"
    }, null, 8, _hoisted_1),
    _createElementVNode("figcaption", {
      class: "break-word text-xs leading-4.5",
      innerHTML: _ctx.caption
    }, null, 8, _hoisted_2),
    (modalActive.value && _ctx.loginWrapper)
      ? (_openBlock(), _createBlock(Vue3Modal, {
          key: 0,
          "mount-to": _ctx.loginWrapper,
          class: "!w-full cursor-default",
          narrow: "",
          headline: _ctx.label,
          onClosed: closeModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.infoText), 1)
          ]),
          _: 1
        }, 8, ["mount-to", "headline"]))
      : _createCommentVNode("", true)
  ]))
}
}

})